import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useIframeStore = defineStore('iframe', () => {
  const isIframeMode = ref(false)
  const agreementResponsible = ref<string | null>(null)

  function setFromMessage(value: string) {
    isIframeMode.value = true
    agreementResponsible.value = value
  }

  return { isIframeMode, agreementResponsible, setFromMessage }
})
